import { useEffect, useState } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
const alertStore = FloatingAlertStore.newFloatingAlertStore();

// Module-level state to track which component should render the global FloatingAlertList
let isGlobalAlertListRendered = false;

// Test utility to reset module state between test runs
export const resetGlobalAlertState = () => {
  isGlobalAlertListRendered = false;
  const alerts = alertStore.getAlerts();
  Object.keys(alerts).forEach(alert => {
    const {
      id
    } = alerts[alert];
    alertStore.removeAlert(id);
  });
};
export const useGlobalAlertStore = () => {
  const [shouldRenderGlobalList, setShouldRenderGlobalList] = useState(false);
  useEffect(() => {
    if (!isGlobalAlertListRendered) {
      isGlobalAlertListRendered = true;
      setShouldRenderGlobalList(true);
    }
    return () => {
      // Only reset if THIS component was the one rendering the list
      if (shouldRenderGlobalList) {
        isGlobalAlertListRendered = false;
        setShouldRenderGlobalList(false);
      }
      // If shouldRenderGlobalList is false, this component wasn't rendering, so no-op
    };
  }, [shouldRenderGlobalList]);
  return {
    alertStore,
    shouldRenderGlobalList
  };
};